import wixData from 'wix-data';
$w.onReady(function () {
    $w('#thankYouPage1').getOrder()
    .then(result => {
        console.log('order=', result); // this logs all the details of the order available on the 'thank you page'
        orderMessageSend(result); 
        displayDelivery(result);
    });
});

function orderMessageSend(order) {
  $w('#affiliatly').postMessage(order);
}

function displayDelivery(order){
  let cartID = order.cartId;
  console.log('cartID for thank you page', cartID)
  wixData.query("sahoot-deliveryEvent")
  .eq('cartId', cartID)
  .find()
  .then( (results) => {
    console.log('results', results)
    if(results.items.length > 0) {
      let item = results.items[0];
      if (item.selfPickup !== true) {
        console.log(item.deliveryDate)
        let date = item.deliveryDate.slice(0, -14);
      const startDate = item.startDate;
        const endDate = item.endDate;
        const daysInWeek = [' יום ראשון', 'יום שני ', 'יום שלישי ', 'יום רביעי ', 'יום חמישי ', 'יום שישי ', 'יום שבת '];
        $w('#deliveryDate').text = date;
        $w('#deliveryTime').text = item.fromTime + '-' + item.toTime
        $w('#deliveryDate').show();
        $w('#deliveryTime').show();
      } else {
         $w('#deliveryDate').text = 'איסוף עצמי'
        $w('#deliveryTime').hide();
      }

    } else {
      // handle case where no matching items found
    }
  } )
  .catch( (err) => {
    let errorMsg = err;
  } );
}